import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Pagination, PaginationItem, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Modal from "@mui/material/Modal";
import { ApiResultModel, ColumnModel, PageInfoModel } from "../../models/common.model";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { GetAllSuppliersInfoRequest, GetAllSuppliersInfoResponse, PaginationInfo, ShowItemRequest } from "../../models/supplierNotice.model";
import { useMutation, useQueryClient } from "react-query";
import { GetAllSuppliersInfo } from "../../services/supplierNotice.service";
import { NOTICEkEY } from "../../config/cacheKey";


const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};
const nextIcon = () => {
    return (
        <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
    );
};
const previusIcon = () => {
    return (
        <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
    );
};
const columns: readonly ColumnModel[] = [
    { id: "supplierName", label: "نام پذیرنده" },
    { id: "fullName", label: "کاربر پذیرنده" },
    { id: "mobileNumber", label: "شماره موبایل کاربر پذیرنده" },
    //{ id: "viewDatePersian", label: "تاریخ مشاهده اطلاعیه" },
];

export default function ModalSuplierInfo({ openModel, noticeKey, setOpenModal }: any) {
    const queryClient = useQueryClient();
    const [open, setOpen] = React.useState<boolean>(openModel);
    const [data, setData] = React.useState<GetAllSuppliersInfoResponse[]>([]);
    const [showInformation, setShowInformation] = React.useState<string | null | undefined>("All");
    const [filterData, setFilterData] = React.useState<GetAllSuppliersInfoResponse[]>([]);
    const [isVisited, setIsVisited] = React.useState<boolean | undefined>();
    const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
        (): PageInfoModel => {
            let pageInfoModel = new PageInfoModel();
            pageInfoModel.pageNumber = -1;
            pageInfoModel.pageSize = 10;
            pageInfoModel.total = 0;

            return pageInfoModel;
        }
    );
    const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
        (): PaginationInfo => {
            let paginationInfo = new PaginationInfo();
            paginationInfo.pageNumber = 1;
            return paginationInfo;
        }
    );
    const handleClose = () => {
        setOpen(false);
        setOpenModal(false)
        setShowInformation("All");
    };
    React.useEffect(() => {
        setOpen(openModel);
        if (noticeKey != undefined && noticeKey != null) {
            let addNoticeKey = {} as ShowItemRequest;
            addNoticeKey.noticeKey = noticeKey;
            if (showInformation === "All") {
                addNoticeKey.isVisited = undefined;
                setIsVisited(undefined);
            } else if (showInformation === "Observed") {
                addNoticeKey.isVisited = true;
                setIsVisited(true);
            } else if (showInformation === "HaveNotBeenSeen") {
                addNoticeKey.isVisited = false;
                setIsVisited(false);
            }
            fillData(addNoticeKey);
            queryClient.setQueryData(NOTICEkEY, addNoticeKey.noticeKey);
        }
        currentPaginationInfo.pageNumber = 1;
        setCurrentPaginationInfo(currentPaginationInfo);
    }, [openModel]);
    React.useEffect(() => {
        if (noticeKey != undefined && noticeKey != null) {
            let addNoticeKey = {} as ShowItemRequest;
            addNoticeKey.noticeKey = noticeKey;
            if (showInformation === "All") {
                addNoticeKey.isVisited = undefined;
                setIsVisited(undefined);
            } else if (showInformation === "Observed") {
                addNoticeKey.isVisited = true;
                setIsVisited(true);
            } else if (showInformation === "HaveNotBeenSeen") {
                addNoticeKey.isVisited = false;
                setIsVisited(false);
            }
            fillData(addNoticeKey);
        }
        currentPaginationInfo.pageNumber = 1;
        setCurrentPaginationInfo(currentPaginationInfo);
    }, []);
    const changePageNumber = (newPageNumber: number) => {
        let addNoticeKey = {} as ShowItemRequest;
        addNoticeKey.noticeKey = noticeKey;
        addNoticeKey.isVisited = isVisited;
        // const supplierUser = queryClient.getQueryData<ShowItemRequest>(NOTICEkEY);
        fillData(addNoticeKey!);
        currentPaginationInfo.pageNumber = newPageNumber;
        setCurrentPaginationInfo(currentPaginationInfo);
    };
    const handleChangePagination = (event: any, value: any) => {
        changePageNumber(value);
    };
    const generateFilter = (filterData: ShowItemRequest): GetAllSuppliersInfoRequest => {
        let request = new GetAllSuppliersInfoRequest();
        request.paginationInfo = currentPaginationInfo;
        request.filter = filterData;
        return request;
    };
    const fillData = (filterData: ShowItemRequest) => {
        let filter = generateFilter(filterData);
        GetAllSupplierInfoMutation.mutate(filter);
    };

    let editDate: any;
    const GetAllSupplierInfoMutation = useMutation(GetAllSuppliersInfo, {
        onSuccess: (result: ApiResultModel<GetAllSuppliersInfoResponse[]>) => {
            if (result) {
                setData(result.data);
                setFilterData(result.data);
                setPageInfo(result.pageInfo);
            }
        },
    });
    const changeShowInformation = (e: any) => {
        setShowInformation(e.target.value);
        changeRadioShowInformation(e.target.value);
    };
    function changeRadioShowInformation(value: any) {
        if (value == "All") {
            setShowInformation(value);
            let addNoticeKey = {} as ShowItemRequest;
            addNoticeKey.noticeKey = queryClient.getQueryData(NOTICEkEY)!;
            addNoticeKey.isVisited = undefined;
            setIsVisited(undefined);
            fillData(addNoticeKey!);
            currentPaginationInfo.pageNumber = 1;
            setCurrentPaginationInfo(currentPaginationInfo);
        } else if (value == "Observed") {
            setShowInformation(value);
            let addNoticeKey = {} as ShowItemRequest;
            addNoticeKey.noticeKey = queryClient.getQueryData(NOTICEkEY)!;
            addNoticeKey.isVisited = true;
            setIsVisited(true);
            fillData(addNoticeKey!);
            currentPaginationInfo.pageNumber = 1;
            setCurrentPaginationInfo(currentPaginationInfo);
        } else if (value == "HaveNotBeenSeen") {
            setShowInformation(value);
            let addNoticeKey = {} as ShowItemRequest;
            addNoticeKey.noticeKey = queryClient.getQueryData(NOTICEkEY)!;
            addNoticeKey.isVisited = false;
            setIsVisited(false);
            fillData(addNoticeKey!);
            currentPaginationInfo.pageNumber = 1;
            setCurrentPaginationInfo(currentPaginationInfo);
        }
    }
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >
                <>
                    <Grid className="verticalCenter">
                        <Box
                            sx={style}
                            style={{ borderRadius: "6px", padding: "2px 25px 2px 25px" }}
                            className="ModalSupplierUserNotice textCenter"
                        >
                            <IconButton onClick={handleClose}>
                                <CloseIcon
                                    style={{
                                        position: "fixed",
                                        zIndex: "1",
                                        left: "1vh",
                                        color: "red",
                                        top: "1vh",
                                    }}
                                />
                            </IconButton>
                            <Grid item xs={12} style={{ paddingTop: "1.5vh", textAlign: "right", right: '5vh' }}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        onChange={changeShowInformation}
                                        value={showInformation}
                                        defaultValue={showInformation ? showInformation : "All"}
                                    >
                                        <FormLabel
                                            id="demo-row-radio-buttons-group-label"
                                            className="colorDefaultFont textFont16"
                                            style={{ alignSelf: "center" }}
                                        >
                                            نحوه نمایش اطلاعیه ها:{" "}
                                        </FormLabel>
                                        <FormControlLabel
                                            value="All"
                                            control={
                                                <Radio
                                                    className={`${showInformation == "All"
                                                        ? "SuccessDefaultFont"
                                                        : showInformation == undefined
                                                            ? "SuccessDefaultFont"
                                                            : "disableColor"
                                                        }`}
                                                />
                                            }
                                            className="colorDefaultFont textFont16"
                                            label="همه"
                                        />
                                        <FormControlLabel
                                            value="Observed"
                                            control={
                                                <Radio
                                                    className={`${showInformation == "Observed"
                                                        ? "SuccessDefaultFont"
                                                        : "disableColor"
                                                        }`}
                                                />
                                            }
                                            className="colorDefaultFont textFont16"
                                            label="مشاهده شده"
                                        />
                                        <FormControlLabel
                                            value="HaveNotBeenSeen"
                                            control={
                                                <Radio
                                                    className={`${showInformation == "HaveNotBeenSeen"
                                                        ? "SuccessDefaultFont"
                                                        : "disableColor"
                                                        }`}
                                                />
                                            }
                                            className="colorDefaultFont textFont16"
                                            label="مشاهده نشده"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} style={{ paddingTop: "1.5vh" }}>
                                <div className="cardTableBorder">
                                    <TableContainer style={{ background: "#fff", maxHeight: '55vh' }} className="boxScroll">
                                        <Table
                                            stickyHeader
                                            aria-label="sticky table tabsScroll"
                                            style={{ borderCollapse: "collapse" }}
                                        >
                                            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                                                <TableRow
                                                // classes={{ root: classes.select }}
                                                // className={`${classes} borderRight borderLeft`}
                                                // selected={selectedRow === 0}
                                                >
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            className="rowTHead colorTitle textFont14  noWrap"
                                                            key={column.id}
                                                            align="right"
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell
                                                        className="rowTHead colorTitle textFont14  noWrap"
                                                        align="right"
                                                    >
                                                        تاریخ مشاهده اطلاعیه
                                                    </TableCell>
                                                    <TableCell
                                                        className="rowTHead colorTitle textFont14  noWrap"
                                                        align="right"
                                                    >
                                                        بازدید
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <div style={{ width: "100%", height: "10px" }}></div>
                                            <TableBody>
                                                {filterData
                                                    ? filterData.map((row, rowIndex) => {
                                                        return (
                                                            <TableRow
                                                                // classes={{ root: classes.select }}
                                                                // className={`${rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                                                                //     } ${classes} borderRight borderLeft cursorPointer noWrap`}
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                            // key={row.noticeKey}
                                                            // selected={selectedRow === rowIndex}
                                                            >
                                                                {columns.map((column) => {
                                                                    const value =
                                                                        row[
                                                                        column.id as keyof GetAllSuppliersInfoResponse
                                                                        ];
                                                                    return (
                                                                        <>
                                                                            <TableCell
                                                                                className={`${column.id == "viewDatePersian" ? "actionButtonHeader fontBlueColor textFont14" : "fontBlueColor textFont14"}`}
                                                                                key={column.id}
                                                                                align="right"
                                                                            >
                                                                                {
                                                                                    column.format && column.hasFormat
                                                                                        ? column.format(value)
                                                                                        : value?.toString()}
                                                                            </TableCell>
                                                                        </>
                                                                    );
                                                                })}
                                                                <TableCell
                                                                    className={`${row.viewDatePersian ? "actionButtonHeader fontBlueColor textFont14" : "fontBlueColor textFont14"}`}
                                                                    align="right"
                                                                >

                                                                    {
                                                                        row.viewDatePersian
                                                                    }
                                                                </TableCell>
                                                                <TableCell>
                                                                    <DoneAllIcon
                                                                        scale="scale(1.8) "
                                                                        className={`${row.visit ? " SuccessDefaultFont" : " disableMoreHorizIcon "}`}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                    : null}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <div></div>
                                <div>
                                    <div className="row"></div>
                                    <Grid container xs={12}>
                                        <Grid item xs={4}>
                                            <span
                                                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
                                            >
                                                تعداد کل :
                                                <span style={{ color: "#01AF43" }}>{pageInfo.total}</span>{" "}
                                                مورد
                                            </span>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Pagination
                                                renderItem={(item) => (
                                                    <PaginationItem
                                                        components={{
                                                            previous: previusIcon,
                                                            next: nextIcon,
                                                        }}
                                                        {...item}
                                                    />
                                                )}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center !important",
                                                    direction: "ltr",
                                                    margin: "5px",
                                                    button: {
                                                        color: "#25D1C9",
                                                        fontSize: "14px !important",
                                                        fontFamily: "iranSans",
                                                    },
                                                }}
                                                count={
                                                    pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                                                }
                                                onChange={handleChangePagination}
                                                page={currentPaginationInfo.pageNumber}
                                            />
                                        </Grid>
                                        <Grid item xs={4}></Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Box>
                    </Grid>
                </>
            </Modal>
        </div>
    );
}


